/* Template: Microsites
 ========================================================================== */

template.microsites = function() {
    'use strict';

    const msTitle = $('.site-header_microsites__title'),
        siteHeader = $('.site-header_top'),
        msLinks = $('.site-header_microsites__links'),
        headerSearch = siteHeader.find('.search-form input[type=search]'),
        siteNavigation = $('#site-navigation');

    var topHeader = new Vue({
        el: '#site-header_top',
        mixins: [ VueFocus.mixin ],
        data: {
            bgisgreen: false,
            micrositeVisible: false,
            searchFocused: false,
        },
        methods: {
            toggleDropdown: () => {
                if ( !this.bgisgreen && !this.micrositeVisible ) {
                    msTitle.addClass('active open');
                    siteHeader.addClass('active');
                    msLinks.addClass('open');
                    this.bgisgreen = true;
                    this.micrositeVisible = true;
                } else if ( this.bgisgreen && !this.micrositeVisible ) {
                    msTitle.addClass('active open');
                    msLinks.addClass('open');
                    this.micrositeVisible = true;
                } else if ( this.micrositeVisible ) {
                    msTitle.removeClass('active open');
                    siteHeader.removeClass('active');
                    msLinks.removeClass('open');
                    this.micrositeVisible = false;
                    this.bgisgreen = false;
                }
            },
            focusSearch: () => {
                if ( !this.bgisgreen && !this.micrositeVisible ) {
                    siteHeader.addClass('active');
                    msTitle.addClass('active');
                    headerSearch.addClass('active');
                    this.bgisgreen = true;
                } else if ( this.micrositeVisible ) {
                    msLinks.removeClass('open');
                    msTitle.removeClass('open');
                    this.micrositeVisible = false;
                }
                this.searchFocused = true;
            },
            blurSearch: () => {
                if ( this.searchFocused && !this.micrositeVisible ) {
                    siteHeader.removeClass('active');
                    msTitle.removeClass('active');
                    this.bgisgreen = false;
                }
                this.searchFocused = false;
            }
        }
    });

};
